/**
 * @desc 新增列字段
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.TableColumnAddRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tableColumn/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
